import { EMAIL_RULE, validateNotWhitespaceOnly } from '@helpers/utils';
import ChevronDown from '@img/icons/angle-down.svg';
import SvgEdit from '@img/icons/edit.svg';
import Button from '@stories/Components/Buttons/Button/Button';
import CtaLink from '@stories/Components/Buttons/CtaLink/CtaLink';
import CheckboxField from '@stories/Components/FormFields/CheckboxField/CheckboxField';
import LongTextField from '@stories/Components/FormFields/LongTextField/LongTextField';
import RadioField from '@stories/Components/FormFields/RadioField/RadioField';
import SelectField from '@stories/Components/FormFields/SelectField/SelectField';
import TextField from '@stories/Components/FormFields/TextField/TextField';
import RadioBtn from '@stories/Components/Inputs/RadioBtn/RadioBtn';
import React from 'react';
import { useFieldArray, useForm, } from 'react-hook-form';
import { BookEventFormStyles } from '../../BookEventForm.styles';
import { StepTwoStyles as S } from './StepTwo.styles';
const AttendeeForm = ({ openByDefault, form, register, i, dirtyFields, errors, setValue, titleOptions, dietaryOptions, contactOptions, customQuestions, companyDetails, trigger, }) => {
    const contactsRef = React.useRef(null);
    const [active, setActive] = React.useState(openByDefault);
    const [filledFields, setFilledFields] = React.useState([]);
    const [selectedContact, setSelectedContact] = React.useState(!!form.contactId);
    React.useEffect(() => {
        if (form.willAddDetailsLater) {
            clearDetails(true);
            // Wait for the fields to clear, and become read only, before closing the section
            setTimeout(() => {
                setActive(false);
            }, 500);
        }
    }, [form.willAddDetailsLater]);
    React.useEffect(() => {
        if (form.memberOfMyCompany) {
            setValue(`attendees.${i}.companyName`, companyDetails.name);
            setValue(`attendees.${i}.companyDescription`, companyDetails.description);
            setFilledFields([...filledFields, 'companyName', 'companyDescription']);
        }
        else {
            if (form.companyName === companyDetails.name) {
                setValue(`attendees.${i}.companyName`, '');
                setValue(`attendees.${i}.companyDescription`, '');
            }
            const dup = filledFields;
            let index = dup.indexOf('companyName');
            if (index > -1) {
                dup.splice(index, 1);
            }
            index = dup.indexOf('companyDescription');
            if (index > -1) {
                dup.splice(index, 1);
            }
            setFilledFields(dup);
        }
    }, [form.memberOfMyCompany]);
    React.useEffect(() => {
        if (form.contactId && contactsRef.current) {
            contactsRef.current.value = `option_${form.contactId}`;
            lockFields(form.contactId);
        }
    }, []);
    return (React.createElement(S.AttendeeFormWrapper, { "data-active": active },
        React.createElement(S.AttendeeFormTitle, { onClick: () => setActive(!active) },
            errors && React.createElement("span", null, "!"),
            form.formTitle,
            React.createElement(ChevronDown, null)),
        React.createElement(S.Collapsible, { active: active },
            React.createElement(S.AttendeeFormInner, null,
                React.createElement("input", { type: "hidden", ...register(`attendees.${i}.formId`) }),
                React.createElement("input", { type: "hidden", ...register(`attendees.${i}.attendeeNumber`) }),
                React.createElement(S.FormWrapper, { "data-disabled": form.willAddDetailsLater },
                    React.createElement(BookEventFormStyles.SplitFields, null,
                        React.createElement(BookEventFormStyles.Field, { "data-contacts-select": "true" },
                            React.createElement(SelectField, { selectRef: contactsRef, "data-has-value": !!form.title, dirty: false, label: "Select from contacts", readOnly: form.willAddDetailsLater, inputProps: {
                                    name: 'select-contact',
                                    onChange: (e) => {
                                        const selectedContactId = e.currentTarget.value.replace('option_', '');
                                        if (selectedContactId === '') {
                                            clearDetails(false);
                                            setSelectedContact(false);
                                        }
                                        else {
                                            lockFields(selectedContactId);
                                            setSelectedContact(true);
                                        }
                                    },
                                } },
                                React.createElement("option", { value: "", selected: true }, "Add a new attendee"),
                                contactOptions.map((option, j) => (React.createElement("option", { key: `StepTwo_AttendeeForm_ContactOptions_${i}_${j}`, value: `option_${option.contactId}` },
                                    option.surname,
                                    ", ",
                                    option.forename,
                                    ' ',
                                    option.companyName &&
                                        `(${option.companyName}${option.jobTitle ? `, ${option.jobTitle}` : ''})`))))),
                        React.createElement(BookEventFormStyles.Field, null,
                            React.createElement(SelectField, { "data-has-value": !!form.title, dirty: dirtyFields?.title ?? false, error: errors?.title, inputProps: register(`attendees.${i}.title`, {
                                    required: form.willAddDetailsLater
                                        ? false
                                        : `Please select the attendee's title`,
                                }), label: "Title*", readOnly: form.willAddDetailsLater || filledFields.includes(`title`), placeholder: "Select title" }, titleOptions.map((option, j) => (React.createElement("option", { key: `StepTwo_AttendeeForm_TitleOptions_${i}_${j}`, value: option.value }, option.text)))))),
                    React.createElement(BookEventFormStyles.SplitFields, null,
                        React.createElement(BookEventFormStyles.Field, null,
                            React.createElement(TextField, { dirty: dirtyFields?.forename ?? false, error: errors?.forename, inputProps: register(`attendees.${i}.forename`, {
                                    required: form.willAddDetailsLater ||
                                        (selectedContact && filledFields.includes(`forename`))
                                        ? false
                                        : `Please enter the attendee's first name`,
                                    validate: form.willAddDetailsLater ||
                                        (selectedContact && filledFields.includes(`forename`))
                                        ? undefined
                                        : {
                                            whitespace: validateNotWhitespaceOnly,
                                        },
                                }), label: "First name*", placeholder: "First name", readOnly: form.willAddDetailsLater || filledFields.includes(`forename`) })),
                        React.createElement(BookEventFormStyles.Field, null,
                            React.createElement(TextField, { dirty: dirtyFields?.surname ?? false, error: errors?.surname, inputProps: register(`attendees.${i}.surname`, {
                                    required: form.willAddDetailsLater ||
                                        (selectedContact && filledFields.includes(`surname`))
                                        ? false
                                        : `Please enter the attendee's surname`,
                                    validate: form.willAddDetailsLater ||
                                        (selectedContact && filledFields.includes(`surname`))
                                        ? undefined
                                        : {
                                            whitespace: validateNotWhitespaceOnly,
                                        },
                                }), label: "Surname*", placeholder: "Surname", readOnly: form.willAddDetailsLater || filledFields.includes(`surname`) }))),
                    React.createElement(BookEventFormStyles.SplitFields, null,
                        React.createElement(BookEventFormStyles.Field, null,
                            React.createElement(TextField, { dirty: dirtyFields?.emailAddress ?? false, error: errors?.emailAddress, inputProps: register(`attendees.${i}.emailAddress`, {
                                    required: form.willAddDetailsLater ||
                                        (selectedContact && filledFields.includes(`emailAddress`))
                                        ? false
                                        : `Please enter the attendee's email address`,
                                    pattern: form.willAddDetailsLater ||
                                        (selectedContact && filledFields.includes(`emailAddress`))
                                        ? undefined
                                        : EMAIL_RULE,
                                }), label: "Email address*", placeholder: "Email address", type: "email", readOnly: form.willAddDetailsLater || filledFields.includes(`emailAddress`) })),
                        React.createElement(BookEventFormStyles.Field, null,
                            React.createElement(TextField, { dirty: dirtyFields?.jobTitle ?? false, error: errors?.jobTitle, inputProps: register(`attendees.${i}.jobTitle`, {
                                    required: form.willAddDetailsLater ||
                                        (selectedContact && filledFields.includes(`jobTitle`))
                                        ? false
                                        : `Please enter the attendee's job title`,
                                    validate: form.willAddDetailsLater ||
                                        (selectedContact && filledFields.includes(`jobTitle`))
                                        ? undefined
                                        : {
                                            whitespace: validateNotWhitespaceOnly,
                                        },
                                }), label: "Job title*", placeholder: "Job title", readOnly: form.willAddDetailsLater || filledFields.includes(`jobTitle`) }))),
                    React.createElement(BookEventFormStyles.Field, null,
                        React.createElement(CheckboxField, { checkboxLabel: `Attendee ${form.attendeeNumber} is a member of my company`, dirty: dirtyFields?.memberOfMyCompany ?? false, error: errors?.memberOfMyCompany, inputProps: register(`attendees.${i}.memberOfMyCompany`), size: "large", readOnly: form.willAddDetailsLater || filledFields.includes(`memberOfMyCompany`) })),
                    React.createElement(BookEventFormStyles.SplitFields, null,
                        React.createElement(BookEventFormStyles.Field, null,
                            React.createElement(TextField, { dirty: dirtyFields?.companyName ?? false, error: errors?.companyName, inputProps: register(`attendees.${i}.companyName`, {
                                    required: form.willAddDetailsLater ||
                                        (selectedContact && filledFields.includes(`companyName`))
                                        ? false
                                        : `Please enter the attendee's company name`,
                                    validate: form.willAddDetailsLater
                                        ? undefined
                                        : {
                                            whitespace: validateNotWhitespaceOnly,
                                        },
                                }), label: "Company name*", placeholder: "Company name", readOnly: form.willAddDetailsLater || filledFields.includes(`companyName`) })),
                        React.createElement(BookEventFormStyles.Field, null,
                            React.createElement(LongTextField, { dirty: dirtyFields?.companyDescription ?? false, error: errors?.companyDescription, inputProps: register(`attendees.${i}.companyDescription`), label: "Company description", placeholder: "Company description", readOnly: form.willAddDetailsLater || filledFields.includes(`companyDescription`) }))),
                    React.createElement(BookEventFormStyles.SplitFields, null,
                        React.createElement(BookEventFormStyles.Field, null,
                            React.createElement(SelectField, { "data-has-value": !!form.dietaryRequirements, dirty: dirtyFields?.dietaryRequirements ?? false, error: errors?.dietaryRequirements, inputProps: register(`attendees.${i}.dietaryRequirements`, {
                                    required: form.willAddDetailsLater
                                        ? false
                                        : `Please select attendee's dietary requirements`,
                                }), label: "Dietary Requirements", readOnly: form.willAddDetailsLater || filledFields.includes(`dietaryRequirements`), required: true, placeholder: "Please select" }, dietaryOptions.map((option, j) => (React.createElement("option", { key: `StepTwo_AttendeeForm_DietaryOptions_${i}_${j}`, value: option.value }, option.text))))),
                        React.createElement(BookEventFormStyles.Field, null,
                            React.createElement(LongTextField, { dirty: dirtyFields?.dietaryRequirementsDetails ?? false, error: errors?.dietaryRequirementsDetails, label: "Please provide more details of dietary requirements", placeholder: "Dietary requirements", readOnly: form.willAddDetailsLater ||
                                    filledFields.includes(`dietaryRequirementsDetails`) ||
                                    form.dietaryRequirements === 'none', inputProps: register(`attendees.${i}.dietaryRequirementsDetails`, {
                                    required: form.dietaryRequirements === 'other' && !form.willAddDetailsLater
                                        ? `Please provide more details about the dietary requirements`
                                        : false,
                                    validate: form.dietaryRequirements === 'other' && !form.willAddDetailsLater
                                        ? {
                                            whitespace: validateNotWhitespaceOnly,
                                        }
                                        : undefined,
                                }) }))),
                    React.createElement(BookEventFormStyles.SplitFields, null,
                        React.createElement(BookEventFormStyles.Field, null,
                            React.createElement(LongTextField, { dirty: dirtyFields?.accessRequirements ?? false, error: errors?.accessRequirements, inputProps: register(`attendees.${i}.accessRequirements`), label: "Access requirements", placeholder: "Access requirements", readOnly: form.willAddDetailsLater || filledFields.includes(`accessRequirements`) })),
                        customQuestions.length > 0 &&
                            customQuestions.map((field) => (React.createElement(BookEventFormStyles.Field, { key: `attendee.${i}.dynamic.${field.id}` }, renderField(field))))),
                    React.createElement(BookEventFormStyles.ExternalLabel, null, "Guest List"),
                    React.createElement(BookEventFormStyles.Field, null,
                        React.createElement(CheckboxField, { checkboxLabel: `It is great exposure to feature on the guest list and it helps other attendees know who is in the room to connect with.  Please tick here for this attendee’s name, job title, company and business activity to be displayed on the printed and electronic guest lists for this event.`, dirty: dirtyFields?.attendeeDetailsOnGuestList ?? false, error: errors?.attendeeDetailsOnGuestList, inputProps: register(`attendees.${i}.attendeeDetailsOnGuestList`), size: "large", readOnly: form.willAddDetailsLater })),
                    React.createElement(BookEventFormStyles.ExternalLabel, null, "Sharing contact details"),
                    React.createElement(BookEventFormStyles.Field, null,
                        React.createElement(CheckboxField, { checkboxLabel: `Tick here if you agree for this attendee's full contact details to be shared with external sponsor(s), partner(s) and host(s) for this event who may contact them about their services.`, dirty: dirtyFields?.attendeeDetailsShared ?? false, error: errors?.attendeeDetailsShared, inputProps: register(`attendees.${i}.attendeeDetailsShared`), size: "large", readOnly: form.willAddDetailsLater }))),
                React.createElement(S.AddLater, null,
                    React.createElement("summary", null,
                        "Do you want to add your attendee details later? ",
                        React.createElement(ChevronDown, null)),
                    React.createElement(CheckboxField, { checkboxLabel: `Please tick here if you need to add details for Attendee ${form.attendeeNumber} at a later date. You can update attendee details up to two days before the event.`, dirty: dirtyFields?.willAddDetailsLater ?? false, error: errors?.willAddDetailsLater, inputProps: register(`attendees.${i}.willAddDetailsLater`), size: "large", readOnly: selectedContact, description: selectedContact ? 'You cannot add details later if you have selected a contact' : '' }))))));
    function clearDetails(willAddDetailsLater) {
        setFilledFields([]);
        // reset all form values
        for (const [key] of Object.entries(form)) {
            if (['formId', 'formTitle', 'attendeeNumber', 'willAddDetailsLater'].includes(key)) {
                continue;
            }
            setValue(`attendees.${i}.${key}`, ['attendeeDetailsOnGuestList', 'attendeeDetailsShared', 'memberOfMyCompany'].includes(key)
                ? undefined
                : '');
        }
        customQuestions.forEach((field) => {
            setValue(`attendees.${i}.customQuestions.${field.id}`, '');
        });
        setValue(`attendees.${i}.willAddDetailsLater`, willAddDetailsLater);
        if (willAddDetailsLater && contactsRef?.current) {
            contactsRef.current.value = '';
            if (errors) {
                trigger(`attendees.${i}`, { shouldFocus: true });
            }
        }
    }
    function renderField(field) {
        const validation = field.requiredField && field.fieldType !== 'charged-option'
            ? { required: form.willAddDetailsLater ? false : 'Please answer this question' }
            : {};
        switch (field.fieldType) {
            case 'checkbox': {
                return (React.createElement(CheckboxField, { checkboxLabel: field.questionText, dirty: !!dirtyFields?.customQuestions?.[`${field.id}`], error: errors?.customQuestions?.[`${field.id}`], inputProps: register(`attendees.${i}.customQuestions.${field.id}`, validation), required: field.requiredField, size: "large", readOnly: form.willAddDetailsLater || filledFields.includes(``) }));
            }
            case 'charged-option': {
                return (React.createElement(CheckboxField, { checkboxLabel: field.questionText, dirty: !!dirtyFields?.customQuestions?.[`${field.id}`], error: errors?.customQuestions?.[`${field.id}`], inputProps: register(`attendees.${i}.customQuestions.${field.id}`, validation), required: false, size: "large", readOnly: form.willAddDetailsLater || filledFields.includes(``) }));
            }
            case 'dropdown': {
                return (React.createElement(SelectField, { dirty: !!dirtyFields?.customQuestions?.[`${field.id}`], error: errors?.customQuestions?.[`${field.id}`], inputProps: register(`attendees.${i}.customQuestions.${field.id}`, validation), label: field.questionText, readOnly: form.willAddDetailsLater || filledFields.includes(``), required: field.requiredField, placeholder: "Please select" }, field.questionAnswers != null &&
                    field.questionAnswers.split('#')?.map((option, j) => (React.createElement("option", { key: `StepTwo_AttendeeForm_Custom_${i}_${field.id}_${j}`, value: option }, option)))));
            }
            case 'multiline': {
                return (React.createElement(LongTextField, { label: field.questionText, placeholder: field.questionText, dirty: !!dirtyFields?.customQuestions?.[`${field.id}`], error: errors?.customQuestions?.[`${field.id}`], inputProps: register(`attendees.${i}.customQuestions.${field.id}`, validation), required: field.requiredField, readOnly: form.willAddDetailsLater || filledFields.includes(``) }));
            }
            case 'radio': {
                return (React.createElement(RadioField, { radioLabel: "", label: field.questionText, dirty: !!dirtyFields?.customQuestions?.[`${field.id}`], error: errors?.customQuestions?.[`${field.id}`], required: field.requiredField, size: "large", readOnly: form.willAddDetailsLater || filledFields.includes(``) }, field.questionAnswers != null &&
                    field.questionAnswers.split('#')?.map((option, j) => (React.createElement(RadioBtn, { key: `StepTwo_AttendeeForm_Custom_${i}_${field.id}_${j}`, id: `StepTwo_AttendeeForm_Custom_${i}_${field.id}_${j}`, htmlFor: `StepTwo_AttendeeForm_Custom_${i}_${field.id}_${j}`, type: "radio", value: option, ...register(`attendees.${i}.customQuestions.${field.id}`, validation) }, option)))));
            }
            case 'textbox':
            default: {
                return (React.createElement(TextField, { label: field.questionText, placeholder: field.questionText, dirty: !!dirtyFields?.customQuestions?.[`${field.id}`], error: errors?.customQuestions?.[`${field.id}`], inputProps: register(`attendees.${i}.customQuestions.${field.id}`, validation), required: field.requiredField, readOnly: form.willAddDetailsLater || filledFields.includes(``) }));
            }
        }
    }
    function lockFields(id) {
        const matchingContact = contactOptions.find((x) => x.contactId === id);
        let dup = filledFields;
        if (matchingContact) {
            for (const [key, value] of Object.entries(matchingContact)) {
                setValue(`attendees.${i}.${key}`, value === undefined ? '' : value);
                dup = [...dup, key];
            }
            setFilledFields(dup);
        }
        else if (contactsRef.current != null) {
            contactsRef.current.value = '';
        }
    }
};
const StepTwo = ({ stepProps, activeStep, step, setActive, response, submit, }) => {
    const { setValue, control, register, formState: { errors, dirtyFields }, getValues, setError, trigger, watch, } = useForm({
        mode: 'onChange',
        shouldUseNativeValidation: false,
    });
    const { fields } = useFieldArray({
        control,
        name: 'attendees',
    });
    const formValues = watch();
    const generateInitialForms = React.useCallback(() => {
        const attendees = stepProps.attendees;
        if (attendees) {
            const forms = [];
            // Some types have multiple people, like a table //
            let grandTotal = 0;
            attendees.forEach((attendee) => {
                for (let ticket = 0; ticket < attendee.quantity; ticket++) {
                    const matchingTicket = stepProps.tickets.find((x) => x.ticketId === attendee.ticketId);
                    if (matchingTicket) {
                        for (let seatNumber = 0; seatNumber < matchingTicket.attendeesPerTicket; seatNumber++) {
                            const formId = `${attendee.ticketId}_${ticket}_${seatNumber}`;
                            grandTotal++;
                            // If we have a response, and the form has not yet been populated, then populate it using the response
                            const dup = !formValues.attendees.length && response?.data && response.data.attendees
                                ? response.data
                                : formValues;
                            // Check if this attendee already exists and populate if they do
                            const existingAttendee = dup.attendees.find((x) => x.formId === formId);
                            const title = matchingTicket.attendeesPerTicket === 1
                                ? `${matchingTicket.ticketName} (Ticket #${ticket + 1})`
                                : `${matchingTicket.ticketName} (Ticket #${ticket + 1}) - Attendee ${seatNumber + 1} of ${matchingTicket.attendeesPerTicket}`;
                            if (existingAttendee) {
                                existingAttendee.attendeeNumber = grandTotal;
                                forms.push(existingAttendee);
                            }
                            else {
                                forms.push({
                                    formTitle: title,
                                    formId,
                                    attendeeNumber: grandTotal,
                                });
                            }
                        }
                    }
                }
            });
            return forms;
        }
        return [];
    }, [stepProps.attendees, stepProps.tickets, response]);
    const [error, setGeneralError] = React.useState('');
    React.useEffect(() => {
        if (response?.validationErrors) {
            const errors = response.validationErrors;
            if (errors) {
                errors.forEach((err) => {
                    if (err) {
                        if (err.errorTypeName === 'GeneralError') {
                            setGeneralError(err.errorMessage ?? '');
                        }
                        else {
                            setError(err.fieldName, {
                                message: err.errorMessage ?? '',
                            });
                        }
                    }
                });
                return;
            }
        }
        setGeneralError('');
    }, [response]);
    React.useEffect(() => {
        if (stepProps.attendees && stepProps.attendees.length > 0) {
            const forms = generateInitialForms();
            setValue('attendees', forms);
        }
    }, [stepProps.attendees, generateInitialForms, setValue]);
    return (React.createElement(S.Container, null,
        React.createElement(BookEventFormStyles.FormStepTitle, { disabled: activeStep <= step || stepProps.success, onClick: () => setActive(step === activeStep ? 0 : step) },
            React.createElement("span", null,
                "2. ",
                stepProps.title),
            activeStep > step && !stepProps.success && (React.createElement(React.Fragment, null,
                React.createElement("span", null, "Edit"),
                React.createElement(SvgEdit, null)))),
        React.createElement(BookEventFormStyles.FormContent, { isActive: step === activeStep },
            React.createElement(BookEventFormStyles.FormContentInner, null,
                error && React.createElement(BookEventFormStyles.FormError, null, error),
                fields.map((form, index) => (React.createElement(AttendeeForm, { key: `StepTwo_AttendeeForm_${form.id}`, register: register, form: formValues.attendees[index], openByDefault: index === 0, i: index, dirtyFields: dirtyFields.attendees ? dirtyFields.attendees[index] : undefined, errors: errors.attendees ? errors.attendees[index] : undefined, titleOptions: stepProps.titleOptions, dietaryOptions: stepProps.dietaryOptions, contactOptions: stepProps.contactOptions, customQuestions: stepProps.customQuestions, companyDetails: stepProps.companyDetails, setValue: setValue, trigger: trigger })))),
            React.createElement(BookEventFormStyles.StepBottom, null,
                React.createElement(CtaLink, { as: "button", onClick: (e) => {
                        e.preventDefault();
                        setActive(1);
                    } }, "Back to Step 1"),
                React.createElement(Button, { buttonType: "orange-solid", onClick: async () => {
                        const valid = await doValidation();
                        if (!valid) {
                            return;
                        }
                        return submit({
                            attendees: getValues().attendees,
                        });
                    } }, "Continue")))));
    async function doValidation() {
        const toValidate = fields.map((_, index) => `attendees.${index}`);
        return trigger(toValidate, { shouldFocus: true });
    }
};
export default StepTwo;
